/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export interface ParsedPrescriptionImageData {
  drug_name: string;
  patient_name: string;
  refills: string;
  medication_display_name?: string | null;
  dose_form?: string | null;
  route?: string | null;
  strength?: string | null;
  quantity?: string | null;
  substitute_allowed?: boolean | null;
  days_supply?: number | null;
  directions?: string | null;
  written_date?: string | null;
  effective_date?: string | null;
  last_fill_date?: string | null;
  prescribing_doctor?: string | null;
  additional_details?: string | null;
}
